import { useContext, useEffect, useState } from 'react';
import { CategoryContext } from '@core/js/components/main/Games/context';

export const useGameCodes = ({ gameCodes, parentEl, parentElementParameters, loaderEl }) => {
    const partSize = 7;
    const gamesBeforeRender = 4;
    const [gameCodesInitial, setGameCodesInitial] = useState(gameCodes);
    const [codes, setCodes] = useState(gameCodesInitial.slice(0, partSize));
    const [observer, setObserver] = useState(null);
    const [isIntersecting, setIsIntersecting] = useState(false);
    const [isLoaderIntersecting, setIsLoaderIntersecting] = useState(false);
    const [observableEl, setObservableEl] = useState(null);
    const { setStateBtn } = useContext(CategoryContext);
    const [sliderWidth, setSliderWidth] = useState({});

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const updateParameters = () => {
        const { clientWidth, scrollWidth, clientHeight } = parentEl.current;
        const gameItemHeight = parentEl.current.childNodes[0].clientHeight;
        setStateBtn && setStateBtn(clientWidth < scrollWidth || clientHeight > 2 * gameItemHeight);
    };

    useEffect(() => {
        setTimeout(() => updateParameters(), 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        parentElementParameters.clientWidth,
        parentElementParameters.scrollWidth,
        sliderWidth.scrollWidth,
        sliderWidth.clientWidth,
        gameCodes
    ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const createObserver = () => {
        const elPosition = codes.length - gamesBeforeRender <= 0 ? codes.length - 1 : codes.length - gamesBeforeRender;
        const el = parentEl.current?.childNodes.item(elPosition);
        const { clientWidth, scrollWidth } = parentEl.current;
        setSliderWidth({ clientWidth, scrollWidth });

        if (el) {
            setObservableEl(el);
            observer.observe(el);
        }
    };

    useEffect(() => {
        if (gameCodesInitial.length !== gameCodes.length) {
            setCodes(gameCodes);
            setGameCodesInitial(gameCodes);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gameCodes]);

    useEffect(() => {
        const newObserver = new IntersectionObserver(
            ([entry]) => setIsIntersecting(entry.isIntersecting),
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.9
            }
        );

        setObserver(newObserver);

        return () => newObserver.disconnect();
    }, []);

    useEffect(() => {
        if (loaderEl.current) {
            const loaderObserver = new IntersectionObserver(
                ([entry]) => setIsLoaderIntersecting(entry.isIntersecting),
                {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.9
                }
            );

            loaderObserver.observe(loaderEl.current);

            return () => loaderObserver.disconnect();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loaderEl.current]);

    useEffect(() => {
        if (observer) {
            createObserver();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [observer, codes]);

    useEffect(() => {
        if (isIntersecting && gameCodes.length !== codes.length) {
            setCodes([...codes, ...gameCodes.slice(codes.length, codes.length + partSize)]);
            observer?.unobserve(observableEl);
        } else if (isLoaderIntersecting && gameCodes.length !== codes.length) {
            setCodes([...codes, ...gameCodes.slice(codes.length, codes.length + partSize)]);
            observer?.unobserve(observableEl);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isIntersecting, isLoaderIntersecting]);

    return codes;
};
